module.exports = __webpack_public_path__ + "static/img/bg-br.ed11f4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/godfather/bg-br.jpg
// module id = imPH
// module chunks = 1